import React from 'react';
import { Link } from 'react-router-dom';
import { ActivityPlace } from '../types';
import './ActivityCard.scss';

interface ActivityCardProps {
  activity: ActivityPlace;
}

const ActivityCard: React.FC<ActivityCardProps> = ({ activity }) => {
  return (
    <Link to={`/activities/${activity.slug}`} className="activity-card-link">
      <div className="activity-card m-2">
        <div className="card-media">
          <img src={activity.thumbnail_url} alt={activity.name} className="card-img" />
          <div className="card-overlay">
            <div className="category-tags">
              {activity.categories.slice(0, 2).map((category, index) => (
                <span key={index} className="category-tag">{category}</span>
              ))}
            </div>
            {activity.status === 'sold_out' && (
              <div className="status-badge sold-out">
                <i className="fas fa-ticket-alt"></i> Sold Out
              </div>
            )}
          </div>
          {activity.status === 'ongoing' && (
            <div className="highlight-badge">
              <i className="fas fa-star"></i> Featured
            </div>
          )}
        </div>

        <div className="card-content">
          <div className="activity-meta">
            <span className="availability" title="Available Today">
              <i className="fas fa-calendar-check icon"></i>
              Open Today
            </span>
          </div>

          <h3 className="card-title text-truncate">{activity.name}</h3>

          <div className="location-info text-truncate">
            <i className="fas fa-map-pin icon"></i>
            <span>{activity.location}</span>
          </div>

          {activity.first_option_category && (
            <div className="activity-options">
              <span className="option-category">{activity.first_option_category}</span>
            </div>
          )}

          <div className="card-footer">
            <div className="price">
              <span className="amount">{activity.currency_symbol}{activity.first_option_price}</span>
              <span className="unit">
                {activity.is_slot ? '/ slot' : '/ booking'}
              </span>
            </div>
            <div className="action">
              <span className="book-now">Book Now</span>
              <i className="fas fa-arrow-right arrow-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ActivityCard;
